/**
 * API配置服务
 * 管理API基本配置
 */
/**
 * API环境类型
 */
export var ApiEnvironment;
(function (ApiEnvironment) {
    ApiEnvironment["DEVELOPMENT"] = "development";
    ApiEnvironment["PRODUCTION"] = "production";
})(ApiEnvironment || (ApiEnvironment = {}));
/**
 * API配置服务
 * 单例模式管理API配置
 */
export class ApiConfigService {
    /**
     * 私有构造函数
     */
    constructor() {
        /**
         * 当前环境
         */
        this._environment = ApiEnvironment.DEVELOPMENT;
        /**
         * 基本URL
         */
        this._baseUrl = '';
        /**
         * 默认头部
         */
        this._defaultHeaders = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };
        /**
         * 服务特定配置
         */
        this._serviceConfigs = new Map();
    }
    /**
     * 获取实例
     */
    static getInstance() {
        if (!ApiConfigService.instance) {
            ApiConfigService.instance = new ApiConfigService();
        }
        return ApiConfigService.instance;
    }
    /**
     * 配置API服务
     * @param options 配置选项
     */
    configure(options) {
        if (options.environment) {
            this._environment = options.environment;
        }
        if (options.baseUrl) {
            this._baseUrl = options.baseUrl;
        }
        if (options.defaultHeaders) {
            this._defaultHeaders = { ...this._defaultHeaders, ...options.defaultHeaders };
        }
    }
    /**
     * 配置特定服务
     * @param serviceName 服务名称
     * @param config 服务配置
     */
    configureService(serviceName, config) {
        this._serviceConfigs.set(serviceName, config);
    }
    /**
     * 获取基本URL
     * @param serviceName 可选的服务名称
     * @returns 基本URL
     */
    getBaseUrl(serviceName) {
        if (serviceName && this._serviceConfigs.has(serviceName)) {
            const serviceConfig = this._serviceConfigs.get(serviceName);
            if (serviceConfig?.baseUrl) {
                return serviceConfig.baseUrl;
            }
        }
        return this._baseUrl;
    }
    /**
     * 获取默认头部
     * @param serviceName 可选的服务名称
     * @returns 默认头部
     */
    getDefaultHeaders(serviceName) {
        const headers = { ...this._defaultHeaders };
        if (serviceName && this._serviceConfigs.has(serviceName)) {
            const serviceConfig = this._serviceConfigs.get(serviceName);
            if (serviceConfig?.headers) {
                return { ...headers, ...serviceConfig.headers };
            }
        }
        return headers;
    }
    /**
     * 获取当前环境
     * @returns 当前环境
     */
    getEnvironment() {
        return this._environment;
    }
    /**
     * 是否为开发环境
     * @returns 是否为开发环境
     */
    isDevelopment() {
        return this._environment === ApiEnvironment.DEVELOPMENT;
    }
    /**
     * 是否为生产环境
     * @returns 是否为生产环境
     */
    isProduction() {
        return this._environment === ApiEnvironment.PRODUCTION;
    }
    /**
     * 重置配置
     */
    reset() {
        this._environment = ApiEnvironment.DEVELOPMENT;
        this._baseUrl = '';
        this._defaultHeaders = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };
        this._serviceConfigs.clear();
    }
}
//# sourceMappingURL=api-config.service.js.map